import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import api from "../../api/http";
import "../../styles/produs/SRBannerSlider.css";
import "font-awesome/css/font-awesome.min.css";

const AUTO_MS = 6500;

// const BannerSlider = () => {
//   const [banners, setBanners] = useState([]);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [isHovered, setIsHovered] = useState(false);
//
//   const timerRef = useRef(null);
//
//   useEffect(() => {
//     let mounted = true;
//
//     (async () => {
//       try {
//         const res = await api.get("/produs/banners");
//         const data = res.data;
//         const items = Array.isArray(data?.results)
//           ? data.results
//           : Array.isArray(data)
//           ? data
//           : [];
//
//         if (!mounted) return;
//         setBanners(items);
//         setCurrentSlide(0);
//       } catch (err) {
//         console.error("Eroare la obținerea bannerelor:", err);
//       }
//     })();
//
//     return () => {
//       mounted = false;
//     };
//   }, []);
//
//   const hasMany = banners.length > 1;
//
//   const goPrev = () => {
//     if (!hasMany) return;
//     setCurrentSlide((p) => (p - 1 + banners.length) % banners.length);
//   };
//
//   const goNext = () => {
//     if (!hasMany) return;
//     setCurrentSlide((p) => (p + 1) % banners.length);
//   };
//
//   useEffect(() => {
//     if (!hasMany) return;
//
//     const stop = () => {
//       if (timerRef.current) clearInterval(timerRef.current);
//       timerRef.current = null;
//     };
//
//     const start = () => {
//       timerRef.current = setInterval(() => {
//         setCurrentSlide((p) => (p + 1) % banners.length);
//       }, AUTO_MS);
//     };
//
//     stop();
//     if (!isHovered) start();
//
//     return () => stop();
//   }, [banners.length, hasMany, isHovered]);
//
//   const onKeyDown = (e) => {
//     if (!hasMany) return;
//     if (e.key === "ArrowLeft") goPrev();
//     if (e.key === "ArrowRight") goNext();
//   };
//
//   const slides = useMemo(() => {
//     return banners.map((b) => ({
//       id: b?.id ?? `${b?.name_banner ?? "banner"}-${Math.random()}`,
//       src: b?.banner ?? b?.image_banner ?? "",
//       alt: b?.name_banner ?? "banner",
//     }));
//   }, [banners]);
//
//   if (!slides.length || !slides[currentSlide]?.src) return null;
//
//   return (
//     <section
//       className="sr-banner"
//       aria-label="Banner slider"
//       tabIndex={0}
//       onKeyDown={onKeyDown}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       onFocusCapture={() => setIsHovered(true)}
//       onBlurCapture={() => setIsHovered(false)}
//     >
//       <div className="sr-banner__frame">
//         {slides.map((s, idx) => (
//           <div
//             key={s.id}
//             className={[
//               "sr-banner__slide",
//               idx === currentSlide ? "is-active" : "",
//             ].join(" ")}
//             aria-hidden={idx === currentSlide ? "false" : "true"}
//           >
//             <img className="sr-banner__img" src={s.src} alt={s.alt} />
//           </div>
//         ))}
//         <div className="sr-banner__edges" aria-hidden="true" />
//       </div>
//
//       {hasMany && (
//         <>
//           <button
//             type="button"
//             className="sr-banner__arrow sr-banner__arrow--left"
//             onClick={goPrev}
//             aria-label="Previous banner"
//           >
//             <i className="fa fa-chevron-left" aria-hidden="true" />
//           </button>
//
//           <button
//             type="button"
//             className="sr-banner__arrow sr-banner__arrow--right"
//             onClick={goNext}
//             aria-label="Next banner"
//           >
//             <i className="fa fa-chevron-right" aria-hidden="true" />
//           </button>
//
//           <div className="sr-banner__dots" aria-label="Slide indicators">
//             {slides.map((_, idx) => (
//               <button
//                 key={idx}
//                 type="button"
//                 className={[
//                   "sr-banner__dot",
//                   idx === currentSlide ? "is-active" : "",
//                 ].join(" ")}
//                 onClick={() => setCurrentSlide(idx)}
//                 aria-label={`Go to slide ${idx + 1}`}
//                 aria-current={idx === currentSlide ? "true" : "false"}
//               />
//             ))}
//           </div>
//         </>
//       )}
//     </section>
//   );
// };

export const BannerSlider = () => {
  const [banners, setBanners] = useState([]);
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const res = await api.get("/produs/banners");
        const data = res.data;
        const items = Array.isArray(data?.results)
          ? data.results
          : Array.isArray(data)
          ? data
          : [];

        if (!mounted) return;
        setBanners(items);
        setCurrent(0);
      } catch (err) {
        console.error("Eroare la obținerea bannerelor:", err);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  const slides = useMemo(() => {
    return banners.map((b) => ({
      id: b?.id ?? `banner-${Math.random()}`,
      img: b?.banner ?? b?.image_banner ?? "",
      eyebrow: b?.eyebrow ?? "Supreme Rentals",
      title: b?.title ?? b?.name_banner ?? "Mașina perfectă\nte așteaptă",
      sub: b?.subtitle ?? b?.description ?? "Flota noastră premium",
      cta: b?.cta_text ?? "Explorează flota",
    }));
  }, [banners]);

  const total = slides.length;

  const goTo = useCallback((idx) => {
    setCurrent((idx + total) % total);
  }, [total]);

  const start = useCallback(() => {
    intervalRef.current = setInterval(() => {
      setCurrent((c) => (c + 1) % total);
    }, 5500);
  }, [total]);

  useEffect(() => {
    if (!paused && total > 0) start();
    return () => clearInterval(intervalRef.current);
  }, [paused, start, total]);

  const handlePrev = () => {
    clearInterval(intervalRef.current);
    goTo(current - 1);
    start();
  };

  const handleNext = () => {
    clearInterval(intervalRef.current);
    goTo(current + 1);
    start();
  };

  if (slides.length === 0) return null;

  return (
    <div
      className="srBanner"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      aria-label="Banner carousel"
    >
      <div
        className="srBanner_track"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {slides.map((slide, i) => (
          <div
            key={slide.id}
            className={`srBanner_slide${i === current ? " is-active" : ""}`}
            aria-hidden={i !== current}
          >
            <img
              className="srBanner_img"
              src={slide.img}
              alt=""
              aria-hidden="true"
              draggable={false}
            />
            <div className="srBanner_overlay" aria-hidden="true" />

            <div className="srBanner_content">
              <p className="srBanner_eyebrow">{slide.eyebrow}</p>
              <h1 className="srBanner_title">
                {slide.title.split("\n").map((line, j) => (
                  <React.Fragment key={j}>
                    {line}
                    {j < slide.title.split("\n").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </h1>
              <p className="srBanner_sub">{slide.sub}</p>
              <a href="#products" className="srBanner_cta">
                {slide.cta}
              </a>
            </div>
          </div>
        ))}
      </div>

      {slides.length > 1 && (
        <>
          <button
            className="srBanner_arrow srBanner_arrow--prev"
            onClick={handlePrev}
            aria-label="Slide anterior"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <button
            className="srBanner_arrow srBanner_arrow--next"
            onClick={handleNext}
            aria-label="Slide următor"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>

          <ul className="srBanner_dots" role="tablist" aria-label="Selectează slide">
            {slides.map((_, i) => (
              <li
                key={i}
                role="tab"
                aria-selected={i === current}
                aria-label={`Slide ${i + 1}`}
                className={`srBanner_dot${i === current ? " is-active" : ""}`}
                onClick={() => {
                  clearInterval(intervalRef.current);
                  goTo(i);
                  start();
                }}
              />
            ))}
          </ul>
        </>
      )}

      <div className="srBanner_stripe" aria-hidden="true" />
    </div>
  );
};

export default BannerSlider;